import { Box } from '@material-ui/core';
import { CSSProperties } from '@material-ui/styles';

import { Font } from '@/components/shared/components/Font';
import { Icon } from '@/components/shared/components/Icon';
import { StandardButton } from '@/components/shared/components/StandardButton';
import { Text } from '@/components/shared/components/Text';
import { useNotificationsContext } from '@/contexts/NotificationsContext/NotificationsContext';
import { useCustomTheme } from '@/hooks/useCustomTheme';

interface DistributionTextFieldProps {
  value: string;
  copyToClipboard: boolean;
  className?: string;
  style?: CSSProperties;
}

export const DistributionTextField = ({ ...props }: DistributionTextFieldProps) => {
  const {
    actions: { setSnackbarNotification },
  } = useNotificationsContext();
  const { palette, customBorderRadius } = useCustomTheme();

  const onCopy = () => {
    navigator.clipboard.writeText(props.value);
    setSnackbarNotification({
      msg: 'COPY_SUCCESSFUL',
      level: 'success',
    });
  };

  return (
    <Box width={'100%'} display={'flex'} alignItems={'center'} justifyContent={'space-between'} gridGap={8}>
      <Box
        px={2}
        py={1}
        height={24}
        flexGrow={1}
        display={'flex'}
        alignItems={'center'}
        bgcolor={palette.grey[100]}
        style={{
          color: palette.text.disabled,
          borderRadius: customBorderRadius.paper,
          overflow: 'hidden',
          ...props.style,
        }}
      >
        <Font className={`overflow-text-ellipsis ${props.className ?? ''}`} variant="body2" color="textPrimary">
          <strong>{props.value}</strong>
        </Font>
      </Box>
      {props.copyToClipboard && (
        <StandardButton
          size="small"
          variant="contained"
          color="secondary"
          style={{
            flexShrink: 0,
            height: 40,
            minWidth: 32,
            borderRadius: customBorderRadius.paper,
          }}
          endIcon={<Icon size={16}>content_copy</Icon>}
          onClick={onCopy}
        >
          <Text tId={'COPY'} />
        </StandardButton>
      )}
    </Box>
  );
};
